import { githubFetch } from './client';

export interface GitHubTreeSimplifyRequest {
  owner: string;
  repo: string;
  ref?: string;
  recursive?: boolean;
}

export interface GitHubTreeSimplifyResponse {
  sha: string;
  paths: string[];
}

export async function githubTreeSimplify(
  params: GitHubTreeSimplifyRequest
): Promise<GitHubTreeSimplifyResponse> {
  return githubFetch<GitHubTreeSimplifyResponse>('/rpc/github_tree_simplify', {
    body: params,
  });
}
